let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eEyVs"), load("iCuQy")]).then(() => parcelRequire('4Shbp'));